import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  useTheme,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { ModalProps } from './Modal.types'

export const Modal = (props: ModalProps) => {
  const {
    open,
    handleClose,
    header,
    footer,
    body,
    footerAlignment = 'end',
    headerCloseButton = true,
    isHeaderCloseButtonDisabled = false,
  } = props

  const theme = useTheme()
  let footerAlignmentSetting = 'centre'
  if (footerAlignment === 'start') {
    footerAlignmentSetting = 'flex-start'
  } else if (footerAlignment === 'end') {
    footerAlignmentSetting = 'flex-end'
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth={false}>
      {header && (
        <DialogTitle
          sx={{
            height: '64px',
            padding: '18px 36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            borderRadius: '4px 4px 0px 0px',
          }}
        >
          <Typography variant="h6" component="span">
            {header}
          </Typography>
          {headerCloseButton && (
            <IconButton
              onClick={handleClose}
              disabled={isHeaderCloseButtonDisabled}
              sx={{
                filter: 'invert(1)',
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
      )}

      <DialogContent
        sx={{
          padding: '36px 36px',
        }}
      >
        {body}
      </DialogContent>

      {footer && (
        <DialogActions
          sx={{
            padding: '36px 36px',
            justifyContent: footerAlignmentSetting,
          }}
        >
          {footer}
        </DialogActions>
      )}
    </Dialog>
  )
}
